export const GET_ARTICLES = 'news/GET_ARTICLES';
export const GET_ARTICLES_SUCCESS = 'news/GET_ARTICLES_SUCCESS';
export const GET_ARTICLES_FAILURE = 'news/GET_ARTICLES_FAILURE';

export const GET_RELATED_ARTICLES = 'news/GET_RELATED_ARTICLES';
export const GET_RELATED_ARTICLES_SUCCESS = 'news/GET_RELATED_ARTICLES_SUCCESS';
export const GET_RELATED_ARTICLES_FAILURE = 'news/GET_RELATED_ARTICLES_FAILURE';

export const SET_USER_FEEDBACK = 'news/SET_USER_FEEDBACK';
export const SET_USER_FEEDBACK_SUCCESS = 'news/SET_USER_FEEDBACK_SUCCESS';
export const SET_USER_FEEDBACK_FAILURE = 'news/SET_USER_FEEDBACK_FAILURE';

export const GET_USER_FEEDBACK = 'news/GET_USER_FEEDBACK';
export const GET_USER_FEEDBACK_SUCCESS = 'news/GET_USER_FEEDBACK_SUCCESS';
export const GET_USER_FEEDBACK_FAILURE = 'news/GET_USER_FEEDBACK_FAILURE';

export const GET_FACET_DETAIL = 'news/GET_FACET_DETAIL';
export const GET_FACET_DETAIL_SUCCESS = 'news/GET_FACET_DETAIL_SUCCESS';
export const GET_FACET_DETAIL_FAILURE = 'news/GET_FACET_DETAIL_FAILURE';

export const GET_TITLE = 'news/GET_TITLE';
export const GET_TITLE_SUCCESS = 'news/GET_TITLE_SUCCESS';
export const GET_TITLE_FAILURE = 'news/GET_TITLE_FAILURE';

export const USER_AUTHENTICATE_SUCCESS_ACTION = 'USER_AUTHENTICATE_SUCCESS_ACTION';
export const USER_AUTHENTICATE_BEGIN_ACTION = 'USER_AUTHENTICATE_BEGIN_ACTION';
export const USER_AUTHENTICATE_FAIL_ACTION = 'USER_AUTHENTICATE_FAIL_ACTION';
export const USER_LOGOUT_ACTION = 'USER_LOGOUT_ACTION';

// month names mapping
export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];



// WEBPACK FOOTER //
// ./src/constants/index.js